import { render } from "./Users.vue?vue&type=template&id=5bd2d6d4&scoped=true"
import script from "./Users.vue?vue&type=script&lang=js"
export * from "./Users.vue?vue&type=script&lang=js"

import "./Users.vue?vue&type=style&index=0&id=5bd2d6d4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5bd2d6d4"

export default script